import Vuex from "vuex";
import { VLazyImagePlugin } from "v-lazy-image";
import VueCarousel from "vue-carousel";
import {
  FontAwesomeIcon,
  FontAwesomeLayers
} from "@fortawesome/vue-fontawesome";
import OverlayWrapper from "#/OverlayWrapper.vue";
import OverlayMenu from "#/OverlayMenu.vue";
import OverlayToggle from "#/OverlayToggle.vue";
import CountUp from "#/CountUp.vue";
import store from "~/store";

export default class VueHelper {
  static CommonComponents () {
    return {
      FontAwesomeIcon,
      FontAwesomeLayers,
      OverlayWrapper,
      OverlayMenu,
      OverlayToggle,
      CountUp
    };
  }

  static CommonPlugins () {
    return {
      Vuex,
      VLazyImagePlugin,
      VueCarousel
    };
  }

  static Store () {
    const { state } = store;

    // Only replace the initial state if something is set
    /* eslint-disable no-underscore-dangle */
    if ( Object.keys( window.__INITIAL_STATE__ ).length !== 0 ) {
      store.replaceState( Object.assign( {}, state, window.__INITIAL_STATE__ ) );
    }
    /* eslint-enable no-underscore-dangle */

    return store;
  }
}
